import axios from "axios";
import { UTILITY_LIST_URL } from '../../config/landlordLinks.jsx'
import {toast} from 'react-toastify'

export const FETCH_LL_UTILITY_LIST = 'FETCH_LL_UTILITY_LIST'
export const RECEIVE_LL_UTILITY_LIST = 'RECEIVE_LL_UTILITY_LIST'
export const FAILED_LL_UTILITY_LIST = 'FAILED_LL_UTILITY_LIST'

export function fetchLLUtilityList(){    return (dispatch, getState) => {
        
            let {authStore} = getState();
            let auth = null;
            if(authStore.authData){
                auth = authStore.authData.result.token;
            }
        dispatch({type: FETCH_LL_UTILITY_LIST});
        axios({
            method: 'post',
            url: UTILITY_LIST_URL,
            headers: {
                Authorization: auth
            },
        })
        .then((response) => {
            dispatch( {
                type: RECEIVE_LL_UTILITY_LIST,
                payload: response.data
            })
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_LL_UTILITY_LIST
                    })
                    return toast.error("Invalid username or password! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_LL_UTILITY_LIST
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_LL_UTILITY_LIST
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_LL_UTILITY_LIST
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_LL_UTILITY_LIST
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_LL_UTILITY_LIST
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}